// Shared utils for Material Purchase Order screens

export const MPO_STATUS_COLOR = {
  draft: 'gray',
  pending_approval: 'amber',
  returned: 'purple',
  rejected: 'red',
  approved: 'blue',
  issued: 'cyan',
  partially_received: 'purple',
  fully_received: 'green',
  cancelled: 'red',
  closed: 'gray',
};

export const MPO_STATUS_LABEL = {
  draft: 'Draft',
  pending_approval: 'Pending Approval',
  returned: 'Returned',
  rejected: 'Rejected',
  approved: 'Approved',
  issued: 'Issued',
  partially_received: 'Partially Received',
  fully_received: 'Fully Received',
  cancelled: 'Cancelled',
  closed: 'Closed',
};

export const MPO_DELIVERY_LABEL = {
  pending: 'Pending',
  partially_received: 'Partial',
  fully_received: 'Received',
};

export const MPO_DELIVERY_COLOR = {
  pending: 'amber',
  partially_received: 'blue',
  fully_received: 'green',
};

export const EDITABLE_STATUSES = new Set(['draft', 'returned']);
export const SUBMITTABLE_STATUSES = new Set(['draft', 'returned']);
export const APPROVABLE_STATUSES = new Set(['pending_approval']);
export const RETURNABLE_STATUSES = new Set(['pending_approval']);
export const REJECTABLE_STATUSES = new Set(['pending_approval']);
export const ISSUABLE_STATUSES = new Set(['approved']);
export const CANCELLABLE_STATUSES = new Set(['draft', 'pending_approval', 'approved', 'issued', 'partially_received']);
export const CLOSEABLE_STATUSES = new Set(['fully_received']);

export function fmt(n) {
  const num = parseFloat(n) || 0;
  return '₦' + num.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtDate(d) {
  if (!d) return '—';
  try {
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return d;
    return `${String(dt.getDate()).padStart(2, '0')}-${String(dt.getMonth() + 1).padStart(2, '0')}-${dt.getFullYear()}`;
  } catch { return d; }
}

export function calcItemAmount(qty, rate, disc = 0) {
  const q = parseFloat(qty || 0);
  const r = parseFloat(rate || 0);
  const d = parseFloat(disc || 0);
  const factor = d > 0 ? (1 - d / 100) : 1;
  return Math.round(q * r * factor * 100) / 100;
}

export function calcItemVat(amount, vatPct) {
  if (!vatPct) return 0;
  return Math.round(parseFloat(amount) * parseFloat(vatPct) / 100 * 100) / 100;
}

export function calcTotals(items) {
  let subtotal = 0, vat = 0;
  for (const it of items) {
    subtotal += parseFloat(it.amount || 0);
    vat += parseFloat(it.vat_amount || 0);
  }
  subtotal = Math.round(subtotal * 100) / 100;
  vat = Math.round(vat * 100) / 100;
  return { subtotal_amount: subtotal, vat_amount: vat, grand_total: Math.round((subtotal + vat) * 100) / 100 };
}
